export default "__VITE_ASSET__DLg1topU__"